<!-- <div class="body__content"> -->
  <div class="body__options container-body-options"   [ngClass]="selectedOption === 'LICENSE_TYPE' ? 'show': 'hide'">
      <p *ngIf="selectedVehicle === null">Seleccione un equipo en la licencia.</p>
      <div class="row mb-4" *ngIf="selectedVehicle !== null">
          <div class="col-12 col-md-4 body__col" >
              <h5>Vehículo registrado</h5>
              <div class="d-flex">
                  <p>
                    {{selectedVehicle.equipmentName}}
                    <br>
                    {{selectedVehicle.equipmentBrand}}
                    -
                    {{selectedVehicle.equipmentModel}}
                  </p>
              </div>
          </div>
          <div class="col-12 col-md-4 body__col">
              <div class="form">
                  <label for="" class="label">Tipo de licencia</label>
                  <div class="d-flex">
                      <div class="mr-5">
                        <div class="form__check mb-2" *ngFor="let item of licenseTypes; index as i;">
                          <ng-container *ngFor="let control of [asFormGroup(asFormArray(newEquipmentForm.controls.licenseTypes).at(i))]">
                            <input
                              type="checkbox"
                              id="opt2{{item.name}}{{item.id}}"
                              [formControl]="asFormControl(control.controls.active)"
                              [attr.disabled]="asFormControl(control.controls.disabled).value ? true : null"
                              [ngClass]="{'global-no-pointer-events': asFormControl(control.controls.disabled).value}"
                            >
                            <label
                              for="opt2{{item.name}}{{item.id}}"
                              [ngClass]="{'global-no-pointer-events': asFormControl(control.controls.disabled).value}"
                            >
                              <div
                                class="fakebox"
                                [ngClass]="{
                                  'global-no-pointer-events': asFormControl(control.controls.disabled).value,
                                  'dark-grey-bg': asFormControl(control.controls.disabled).value
                                }"
                              ></div>
                              {{ item.name }}
                            </label>
                          </ng-container>
                        </div>
                      </div>
                  </div>
              </div>
          </div>
          <div class="col-12 col-md-4">
              <div class="form">
                  <label for="" class="label">
                  Área de conducción
              </label>
                  <div class="d-flex">
                    <div class="mr-5">
                        <div class="form__check mb-2 global-no-pointer-events" *ngFor="let item of conductionZones | slice: 0 : round(conductionZones.length/2) ;index as i">
                          <ng-container *ngFor="let control of [getCheckControls(item.id)]">
                            <ng-container *ngIf="control.active.value">
                              <label for="opt2{{item.name}}{{item.id}}">
                              <div class="fakebox point"></div>
                              {{ item.name }}
                              </label>
                            </ng-container>
                          </ng-container>
                        </div>
                    </div>
                    <div>
                      <div class="form__check mb-2 global-no-pointer-events" *ngFor="let item of conductionZones | slice: round(conductionZones.length/2) : conductionZones.length ;index as i">
                        <ng-container *ngFor="let control of [getCheckControls(item.id)]">
                          <ng-container *ngIf="control.active.value">
                            <label for="opt2{{item.name}}{{item.id}}">
                            <div class="fakebox point"></div>
                            {{ item.name }}
                            </label>
                          </ng-container>
                        </ng-container>
                      </div>
                    </div>
                  </div>
              </div>
          </div>
      </div>
      <button
        *ngIf="selectedVehicle !== null"
        [disabled]="newEquipmentForm.valid ? false : true"
        type="button"
        class="btn btn--primary ingresar"
        (click)="onAddNewEquipment()"
      >
        Registrar nuevo tipo de licencia
      </button>
  </div>
<!-- </div> -->
